function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 2h8v8h-2V4H6V2z",
  fill: "#F4F6F8"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 7a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H3a1 1 0 01-1-1V7z",
  fill: "#F4F6F8"
});

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgMkgxNFYxMEgxMlY0SDZWMloiIGZpbGw9IiNGNEY2RjgiLz4KPHBhdGggZD0iTTIgN0MyIDYuNDQ3NzIgMi40NDc3MiA2IDMgNkg5QzkuNTUyMjggNiAxMCA2LjQ0NzcyIDEwIDdWMTNDMTAgMTMuNTUyMyA5LjU1MjI4IDE0IDkgMTRIM0MyLjQ0NzcyIDE0IDIgMTMuNTUyMyAyIDEzVjdaIiBmaWxsPSIjRjRGNkY4Ii8+Cjwvc3ZnPg==";
export { SvgCopy as ReactComponent };